// Tasks slice – manages tasks state and selectors
import { createSlice } from "@reduxjs/toolkit";

const savedTasks = JSON.parse(localStorage.getItem("tasks")) || [];

const tasksSlice = createSlice({
  name: "tasks",

  initialState: {
    tasks: savedTasks,
    hideDone: false,
    loading: false,
  },

  reducers: {
    addTask: (state, { payload: task }) => {
      state.tasks.push(task);
    },

    removeTask: (state, { payload: taskId }) => {
      state.tasks = state.tasks.filter((task) => task.id !== taskId);
    },

    toggleTaskDone: (state, { payload: taskId }) => {
      const task = state.tasks.find((task) => task.id === taskId);
      if (task) {
        task.done = !task.done;
      }
    },

    setAllDone: (state) => {
      state.tasks.forEach((task) => {
        task.done = true;
      });
    },

    toggleHideDone: (state) => {
      state.hideDone = !state.hideDone;
    },

    fetchExampleTasks: (state) => {
      state.loading = true;
    },

    fetchExampleTasksSuccess: (state, { payload }) => {
      state.tasks = payload;
      state.loading = false;
    },
  },
});

export const {
  addTask,
  removeTask,
  toggleTaskDone,
  setAllDone,
  toggleHideDone,
  fetchExampleTasks,
  fetchExampleTasksSuccess,
} = tasksSlice.actions;

export const selectTasks = (state) => state.tasks.tasks;
export const selectHideDone = (state) => state.tasks.hideDone;
export const selectLoading = (state) => state.tasks.loading;

export const selectFilteredTasks = (state, query) => {
  const tasks = selectTasks(state);

  if (!query?.trim()) {
    return tasks;
  }

  const normalizedQuery = query.trim().toLowerCase();

  return tasks.filter((task) =>
    task.content.toLowerCase().includes(normalizedQuery),
  );
};

export default tasksSlice.reducer;
